import { Office } from '../offices/offices.model';
import { File } from './../../models/files/files.model';

export class OfficeContact {
    id?: string;
    url?: any;
    file?: File;
    offices: Array<Office>;

    constructor(options: any) {
        this.id = options.id;
        this.url = options.url;
        this.file = options.file;
        this.offices = options.offices;
    }
}
